import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isButtonPressed: false,
  orderButtonIsPressed: false,
  headerDrawer: false,
  AssetsList: [],
  theme: 'dark',
};

const rootSlice = createSlice({
  name: "root",
  initialState,
  reducers: {
    setIsButtonPressedAction: (state, action) => {
      state.isButtonPressed = action.payload;
    },
    setOrderButtonAction: (state, action) => {
      state.orderButtonIsPressed = action.payload;
    },
    setHeaderDrawer: (state, action) => {
      state.headerDrawer = action.payload;
    },
    setAssetsList: (state, action) => {
      state.AssetsList = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const {
  setIsButtonPressedAction,
  setOrderButtonAction,
  setHeaderDrawer,
  setAssetsList,
  setTheme,
} = rootSlice.actions;

export default rootSlice.reducer;